import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ensureConfig } from "./config";
import "./index.css";

void ensureConfig()
  .then(() => {
    createRoot(document.getElementById("root")!).render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  })
  .catch((e) => {
    document.body.innerHTML = `<pre style="padding:2rem;color:#b91c1c">${e instanceof Error ? e.message : String(e)}</pre>`;
  });
